import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    stationId: Number,
    channelDataLastId: Number,
    sessionConfigureNotEditable: Boolean,
    stationResourceElect: Boolean,
    valveInProcess: Boolean,
    valveSwitchAfterLastSeance: Boolean,
    confirmMessage: String,
    valveStatusUrl: String,
    valveRefreshUrl: String
  };

  static targets = ['checkboxBlock', 'checkbox', 'submitButton', 'waitingSeanceMessage', 'waitingSeanceCancelButton']

  initialize() {
    console.log("Valve controller connected");
    this.checkDisabledState();
    this.startPolling();
  }

  startPolling() {
    if (!this.valveSwitchAfterLastSeanceValue && this.valveStatusUrlValue) {
      this.pollInterval = setInterval(() => this.checkValveStatus(), 5000);
    }
  }

  stopPolling() {
    if (this.pollInterval) {
      clearInterval(this.pollInterval);
      this.pollInterval = null;
    }
  }

  checkValveStatus() {
    fetch(this.valveStatusUrlValue, {
      headers: { 'Accept': 'application/json' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.valve_switch_after_last_seance === true) {
          this.stopPolling();
          this.refreshValveTab();
        }
      })
      .catch(error => console.error('Polling error:', error));
  }

  refreshValveTab() {
    const url = this.valveRefreshUrlValue;
    fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }
    })
      .then(response => response.ok ? response.text() : Promise.reject(`Status: ${response.status}`))
      .then(html => {
        document.getElementById('valve-result-container').innerHTML = html;
        document.querySelectorAll('.page-link').forEach((paginateItem) => {
          paginateItem.removeAttribute('href');
          paginateItem.setAttribute('data-action', 'click->stations--show#loadValve');
        });
      })
      .catch(error => console.error('Refresh error:', error));
  }

  checkDisabledState() {
    if (!this.hasCheckboxTarget || !this.hasCheckboxBlockTarget) return;

    if (this.sessionConfigureNotEditableValue || this.stationResourceElectValue || this.valveInProcessValue) {
      this.disableCheckbox();
    }
    if (this.valveInProcessValue && !this.sessionConfigureNotEditableValue){
      this.waitingSeanceMessageTarget.classList.remove('d-none');
      this.waitingSeanceCancelButtonTarget.classList.remove('d-none');
    }
  }

  disableCheckbox() {
    this.checkboxTarget.disabled = true;
    this.checkboxBlockTarget.classList.add('custom-switch-disabled');
  }

  cancelWaitingSeanceAction() {
    this.stopPolling();
    if (!this.hasCheckboxTarget || !this.hasWaitingSeanceCancelButtonTarget || !this.hasWaitingSeanceMessageTarget) return;

    this.checkboxTarget.disabled = false;
    this.checkboxBlockTarget.classList.remove('custom-switch-disabled');
    this.waitingSeanceCancelButtonTarget.classList.add('d-none');
    this.waitingSeanceMessageTarget.classList.add('d-none');

    const params = new URLSearchParams({
      'channel_datum[archive_type]': 'valve',
      'channel_datum[property][canceled]': true
    });

    const url = `/stations/${this.stationIdValue}/channel_data/${this.channelDataLastIdValue}?${params}`;
    fetch(url, { 
      method: 'PATCH', 
      headers: { 
        'X-Requested-With': 'XMLHttpRequest', 
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content 
      } 
    })
      .then(response => response.json())
      .then(data => {
        console.log('Canceled:', data.message);
        this.refreshValveTab();
      })
      .catch(error => console.error('Cancel error:', error));
  }


  toggle(event) {
    event.preventDefault();
     if (!this.hasCheckboxTarget) return;

    const checked = this.checkboxTarget.checked;

    this.previousState = !checked;

    if (confirm(this.confirmMessageValue)) {
      this.submitButtonTarget.click();
      this.waitingSeanceCancelButtonTarget.classList.remove('d-none');
      this.waitingSeanceMessageTarget.classList.remove('d-none');
    } else {
      this.checkboxTarget.checked = this.previousState;
    }
  }
}
